import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
/** UTIILS */

export interface ProductTypesInterface {
  group: string
  productTypeName: string
  productTypeNameEn: string
  status?: string
}

export default class ProductTypesApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get('product-types', { params: { ...props } }).then((res) => res)
  }
  static create(payload: any) {
    return this.api.post('product-types', payload)
  }
  static findById(id: number): Promise<ProductTypesInterface> {
    return this.api.get(`product-types/${id}`)
  }
  static update(id: number, body: ProductTypesInterface) {
    return this.api.patch(`product-types/${id}`, body)
  }
  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`product-types/${id}/status`, { id, status })
  }
  static remove(id: number) {
    return this.api.delete(`product-types/${id}`)
  }
}
